import { Route, Routes } from "react-router-dom";
import NotFound from "../screens/refonte/NotFound";
import Forbiden from "../screens/refonte/Forbiden";
import { AuthProvider, useAuth } from "./AuthContext";
import DashboardPage from "../screens/refonte/admin/dashboard/DashboardPage";
import RecrutementPage from "../screens/refonte/admin/recrutement/RecrutementPage";
import AssociationsPage from "../screens/refonte/admin/association/AssociationsPage";
import VolontariatPage from "../screens/refonte/admin/recrutement/volontariat/VolontariatPage";
import ConsultantPage from "../screens/refonte/admin/recrutement/consultant/ConsultantPage";
import AssociationsMembersPage from "../screens/refonte/admin/association/AssociationsMembersPage";
import ParametragePage from "../screens/refonte/admin/parametrage/ParametragePage";
import SQCFormPage from "../screens/refonte/admin/parametrage/AMI/sqc_formulaire/SQCFormPage";
import SQCFormQuestionPage from "../screens/refonte/admin/parametrage/AMI/sqc_formulaire/SQCFormQuestionPage";
import AgexPage from "../screens/refonte/admin/recrutement/agex/AgexPage";
import AdministrateursPage from "../screens/refonte/admin/administrateurs/AdministrateursPage";
import SousDomainePage from "../screens/refonte/admin/parametrage/AMI/domaine_sous_domaine/SousDomainePage";
import Profile from "../screens/refonte/profile/Profile";

const AdminRoutes = () => {
  const isAuthenticated = useAuth(); // localStorage.getItem("token") !== null;
  const current_url = window.location.href;
  const is_administration = current_url.split("/")[4] === "administration";
  
  return (
    <>
      {/* <Routes basename="/cv_candidature"> */}
      <AuthProvider>
        {/* <BrowserRouter> */}
        <Routes  basename={""}>
          <Route path="403" element={<Forbiden />} />
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          {/**Route pour l'administration */}
          <Route path="administration">
            <Route path="" element={<AssociationsPage />} />
            <Route path="mon-profile" element={<Profile />} />

            {/** Temporairement caché */}
            <Route path="dashboard">
              <Route path="" element={<DashboardPage />} />
            </Route>
            <Route path="recrutement">
              <Route path="" element={<RecrutementPage />} />
              <Route path="volontariat">
                <Route path="" element={<VolontariatPage />} />
                <Route
                  path="association_membres"
                  element={<AssociationsMembersPage />}
                />
              </Route>
              <Route path="agex">
                <Route path="" element={<AgexPage />} />
                <Route
                  path="association_membres"
                  element={<AssociationsMembersPage />}
                />
              </Route>
              <Route path="consultant" element={<ConsultantPage />} />
            </Route>
            <Route path="associations">
              <Route path="" element={<AssociationsPage />} />
              <Route path="membres" element={<AssociationsMembersPage />} />
            </Route>
            <Route path="parametrage">
              <Route path="" element={<ParametragePage />} />
              <Route path="formulaire">
                <Route path="" element={<SQCFormPage />} />
                <Route path="questions" element={<SQCFormQuestionPage />} />
                <Route path="sous-domaine" element={<SousDomainePage />} />
              </Route>
            </Route>
            <Route path="administrateurs">
              <Route path="" element={<AdministrateursPage />} />
            </Route>
          </Route>

          {/**Route pour l'administration */}
        </Routes>
        {/* </BrowserRouter> */}
      </AuthProvider>
    </>
  );
};

export default AdminRoutes;
